import type { FaireProductEntity } from "../../entity_types/product";

export const p_jg3m7d6yeh: FaireProductEntity = {
  token: "p_jg3m7d6yeh",
  type: "product",
  name: "Hand-painted Mahjong Bag Charm + Keychain | Eco-Friendly",
  brandToken: "b_z4cmjuda3k",
  brandName: "Solar Eclipse",
  imageUrl:
    "https://cdn.faire.com/fastly/e91f0ce89b2695a88ddc0cdc39bbf8ef889acd3ea54879b61f110272553e81c8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/db025d68dfabaebeedd8f08001a694d19d9698dc58d3aca9000978c7c4f34929.jpeg",
    "https://cdn.faire.com/fastly/8fcbcd8e450526bbdf5d10c835e89d944cd30180be8dbcb7bf1da208adebcccc.jpeg",
  ],
  priceDollars: 13,
  description:
    "𝐏𝐫𝐞𝐨𝐫𝐝𝐞𝐫\n\nHand-painted by our Solar Eclipse artists, our original bag charm is crafted in small batches. It's designed to upgrade your favorite bag or set of keys.\n\nDesigned in New York City, the double-sided charm is hand-painted on both sides, for an iconic look from all angles.\n\nCrafted with our super-strong biodegradable acetate, our versatile pieces can be used as a bag charm or a statement keychain.\n\n𝐊𝐞𝐲 𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬\n\n• Original Design: Copyright original design you won't find anywhere else!\n• Hand-painted: Each bag charm is carefully hand-painted by our Solar Eclipse artists.\n• Cellulose Acetate: Crafted from a eco-friendly, biodegradable material made from recycled wood pulp.\n• Extra Strong: Our extra strong acetate and sturdy hardware is ready for action.\n• Keyring + Carabiner: includes a 1.45\" carabiner and 1.3” split keyring.\n• Sustainable Packaging: 100% recyclable & plastic-free packaging.\n\nWe are very proud of our original art. Our copyright designs are protected internationally by intellectual property law.",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:43.532Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
